import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { PostHogProvider } from 'posthog-js/react'

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  loaded: (posthog) => {
    // Set default user properties
    posthog.register({
      app_version: '1.0.0',
      environment: process.env.NODE_ENV || 'production'
    });
  }
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
      <App />
    </PostHogProvider>
  </StrictMode>
)